module.exports = __webpack_public_path__ + "img/Billboard-studio-1-thumb.jpg";